import { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { api } from "../services/api";
import { Link } from "react-router-dom";

const AdminDiscountAssignments = () => {
  const [assignments, setAssignments] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [sortBy, setSortBy] = useState("assigned_at");
  const [sortDir, setSortDir] = useState("desc");
  const [searchQuery, setSearchQuery] = useState("");
  const limit = 20;

  const [allUsers, setAllUsers] = useState([]);
  const [allCodes, setAllCodes] = useState([]);
  const [newAssignment, setNewAssignment] = useState({ user_id: "", discount_code_id: "", max_uses: 1 });
  const [showForm, setShowForm] = useState(false);
  const selectedUser = allUsers.find(u => u.id.toString() === newAssignment.user_id?.toString());

  const [saving, setSaving] = useState(false);

  const fetchData = async (pageToLoad = 1, query = "") => {
    const params = new URLSearchParams({
      page: pageToLoad,
      limit,
      ...(query && { q: query })
    }).toString();

    const res = await api.get(`/api/admin/discount-assignments/list?${params}`);
    setAssignments(res.data.assignments);
    setPage(res.data.page);
    setTotal(res.data.total);
  };

  useEffect(() => {
    fetchData();
    const fetchRefs = async () => {
      const [usersRes, codesRes] = await Promise.all([
        api.get("/api/admin/users/all"),
        api.get("/api/admin/discount-codes/all")
      ]);
      setAllUsers(usersRes.data);
      setAllCodes(codesRes.data);
    };
    fetchRefs();
  }, []);


  const totalPages = Math.ceil(total / limit);

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortDir(sortDir === "asc" ? "desc" : "asc");
    } else {
      setSortBy(field);
      setSortDir("asc");
    }
  };

  const sortedAssignments = [...assignments].sort((a, b) => {
    const aVal = a[sortBy] ?? "";
    const bVal = b[sortBy] ?? "";

    const aStr = aVal.toString().toLowerCase();
    const bStr = bVal.toString().toLowerCase();

    return sortDir === "asc" ? aStr.localeCompare(bStr) : bStr.localeCompare(aStr);
  });

  return (
    <Box sx={{
      backgroundImage: 'url("/assets/bg-pitchest.jpg")',
      backgroundSize: "cover",
      minHeight: "100vh",
      px: 2,
      py: 6,
    }}>
      <Box sx={{ backgroundColor: "rgba(0,0,0,0.6)", borderRadius: 4, p: { xs: 2, md: 4 }, color: "white" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="h5">🎟️ Discount Assignments</Typography>
          <Link to="/admin" style={{ color: "#90caf9", fontWeight: "bold" }}>⬅ Back</Link>
        </Box>

        <Box sx={{ display: "flex", mb: 2 }}>
          <input
            type="text"
            placeholder="Search by email or code"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") fetchData(1, searchQuery);
            }}
            style={{
              padding: "6px 10px",
              width: 250,
              borderRadius: 4,
              border: "1px solid #888",
              backgroundColor: "#222",
              color: "#fff"
            }}
          />
          <Button variant="outlined" onClick={() => fetchData(1, searchQuery)} size="small" sx={{ ml: 1 }}>
            🔍 Search
          </Button>
          <Button
            variant="outlined"
            sx={{ ml: 1 }}
            onClick={() => setShowForm(!showForm)}
          >
            ➕ New Assignment
          </Button>

          {showForm && (
            <Box
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.6)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#452654",
                  borderRadius: 2,
                  p: 4,
                  minWidth: 400,
                  maxWidth: "90vw",
                  boxShadow: 6
                }}
              >
                <Typography variant="body2" sx={{ mb: 2, fontWeight: "bold", color: "#fff" }}>
                  🎟️ Create New Assignment
                </Typography>

                {/* Fila 1: User */}
                <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 1 }}>
                  <label style={{ color: "#fff", fontSize: 14, minWidth: 80 }}>User:</label>
                  <input
                    list="user-options"
                    value={newAssignment.user_id}
                    onChange={(e) => setNewAssignment({ ...newAssignment, user_id: e.target.value })}
                    placeholder="Search user..."
                    style={{
                      padding: "6px 10px",
                      borderRadius: 4,
                      minWidth: 80,
                      maxWidth: 80,
                      backgroundColor: "#222",
                      color: "#fff",
                      border: "1px solid #666"
                    }}
                  />
                  <datalist id="user-options">
                    {allUsers.map((u) => (
                      <option key={u.id} value={u.id}>
                        {u.name} ({u.email})
                      </option>
                    ))}
                  </datalist>
                  {selectedUser && (
                    <Typography variant="body2" sx={{ color: "#ccc" }}>
                      {selectedUser.name} - {selectedUser.email}
                    </Typography>
                  )}
                </Box>

                {/* Fila 2: Discount Code */}
                <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 1 }}>
                  <label style={{ color: "#fff", fontSize: 14, minWidth: 80 }}>Code:</label>
                  <select
                    value={newAssignment.discount_code_id}
                    onChange={(e) => setNewAssignment({ ...newAssignment, discount_code_id: e.target.value })}
                    style={{ padding: "6px 10px", borderRadius: 4, minWidth: 240 }}
                  >
                    <option value="">Select Discount Code</option>
                    {allCodes.map((c) => {
                      let scope = "";
                      if (c.valid_for_plans && c.valid_for_packs) scope = "(Plan/Pack)";
                      else if (c.valid_for_plans) scope = "(Plan)";
                      else if (c.valid_for_packs) scope = "(Pack)";
                      return (
                        <option key={c.id} value={c.id}>
                          {c.code} {scope} — {c.description}
                        </option>
                      );
                    })}
                  </select>
                </Box>

                {/* Fila 3: Max Uses */}
                <Box sx={{ display: "flex", alignItems: "center", mb: 3, gap: 1 }}>
                  <label style={{ color: "#fff", fontSize: 14, minWidth: 80 }}>Max Uses:</label>
                  <select
                    value={newAssignment.max_uses}
                    onChange={(e) => setNewAssignment({ ...newAssignment, max_uses: e.target.value })}
                    style={{ padding: "6px 10px", borderRadius: 4 }}
                  >
                    {[...Array(10)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>{i + 1}</option>
                    ))}
                  </select>
                </Box>

                {/* Fila 4: Opciones de envío */}
                <Box sx={{ display: "flex", alignItems: "center", mb: 3, gap: 2 }}>
                  <label style={{ color: "#fff", fontSize: 14 }}>Send Email:</label>
                  <input
                    type="checkbox"
                    checked={newAssignment.send_email ?? true}
                    onChange={(e) =>
                      setNewAssignment({ ...newAssignment, send_email: e.target.checked })
                    }
                  />
                  <label style={{ color: "#fff", fontSize: 14 }}>Welcome Early Pitchers:</label>
                  <input
                    type="checkbox"
                    checked={newAssignment.early_pitchers ?? false}
                    onChange={(e) =>
                      setNewAssignment({ ...newAssignment, early_pitchers: e.target.checked })
                    }
                  />
                </Box>

                {/* Botones */}
                <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
                  <Button
                    variant="contained"
                    disabled={saving}
                    onClick={async () => {
                      if (!newAssignment.user_id || !newAssignment.discount_code_id) {
                        alert("Please complete all fields");
                        return;
                      }
                      try {
                        setSaving(true);
                        const res = await api.post("/api/admin/discount-assignments", {
                          user_id: Number(newAssignment.user_id),
                          discount_code_id: Number(newAssignment.discount_code_id),
                          max_uses: Number(newAssignment.max_uses),
                          send_email: newAssignment.send_email ?? true,
                          early_pitchers: newAssignment.early_pitchers ?? false,
                        });

                        if (res.data?.email_sent) {
                          alert("✅ Pitchest Admin\n\nAssignment created and email sent successfully.");
                        } else {
                          alert("⚠️ Pitchest Admin\n\nAssignment created, but the email could not be sent.");
                        }

                        setNewAssignment({ user_id: "", discount_code_id: "", max_uses: 1 });
                        setShowForm(false);
                        fetchData();
                      } catch (err) {
                        console.error(err);
                        alert("❌ Error saving assignment");
                      } finally {
                        setSaving(false);
                      }
                    }}
                  >
                    {saving ? "⏳ Saving..." : "✅ Save"}
                  </Button>


                  <Button
                    variant="outlined"
                    disabled={saving}
                    color="error"
                    onClick={() => {
                      setNewAssignment({ user_id: "", discount_code_id: "", max_uses: 1 });
                      setShowForm(false);
                    }}
                  >
                    ❌ Cancel
                  </Button>
                </Box>
              </Box>
            </Box>
          )}

        </Box>

        <Box sx={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", color: "white" }}>
            <thead>
              <tr>
                {[
                  { label: "Assigned At", field: "assigned_at" },
                  { label: "User", field: "user_full_name" },
                  { label: "Email", field: "user_email" },
                  { label: "Code", field: "discount_code" },
                  { label: "Description", field: "description" },
                  { label: "%", field: "discount_percent" },
                  { label: "Used", field: "times_used" },
                  { label: "Max Uses", field: "max_uses" },
                ].map(({ label, field }) => (
                  <th
                    key={field}
                    onClick={() => handleSort(field)}
                    style={{
                      cursor: "pointer",
                      padding: "8px",
                      backgroundColor: "#34163A"
                    }}
                  >
                    {label} {sortBy === field && (sortDir === "asc" ? "▲" : "▼")}
                  </th>
                ))}
                <th style={{ backgroundColor: "#34163A", padding: 8 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {sortedAssignments.map((a, idx) => (
                <tr key={a.id} style={{ backgroundColor: idx % 2 === 0 ? "#5E2F6E" : "transparent" }}>
                  <td style={{ padding: "8px", textAlign: "center" }}>{new Date(a.assigned_at).toLocaleString()}</td>
                  <td style={{ padding: "8px", textAlign: "center" }}>{a.user_full_name}</td>
                  <td style={{ padding: "8px", textAlign: "center" }}>{a.user_email}</td>
                  <td style={{ padding: "8px", textAlign: "center" }}>{a.discount_code}</td>
                  <td style={{ padding: "8px", textAlign: "center" }}>{a.description}</td>
                  <td style={{ padding: "8px", textAlign: "center" }}>{a.discount_percent}%</td>
                  <td style={{ padding: "8px", textAlign: "center" }}>{a.times_used}</td>
                  <td style={{ padding: "8px", textAlign: "center" }}>{a.max_uses}</td>
                  <td style={{ textAlign: "center" }}>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={async () => {
                        const newMax = prompt(
                          "📊 Pitchest Admin\n\nEdit max uses for this assignment:\n• Code: " + a.discount_code +
                          "\n• User: " + a.user_email +
                          `\n\nCurrent max uses: ${a.max_uses}\nEnter new value:`,
                          a.max_uses
                        );
                        if (newMax !== null && newMax !== "") {
                          const parsed = parseInt(newMax);
                          if (isNaN(parsed) || parsed < a.times_used) {
                            alert(
                              "❌ Pitchest Admin\n\nInvalid value.\nMax uses must be a number greater than or equal to times used (" + a.times_used + ")."
                            );
                            return;
                          }

                          await api.patch(`/api/admin/discount-assignments/${a.id}`, {
                            max_uses: parsed
                          });
                          fetchData();
                        }
                      }}
                      title="Edit max uses"
                    >
                      ✏️ Edit
                    </Button>

                    <Button
                      size="small"
                      variant="outlined"
                      color="error"
                      disabled={a.times_used > 0}
                      onClick={async () => {
                        const confirmed = window.confirm(
                          "⚠️ Pitchest Admin\n\nAre you sure you want to permanently delete this assignment?\n\n" +
                          "• Code: " + a.discount_code + "\n" +
                          "• User: " + a.user_email + "\n\n" +
                          "This action cannot be undone."
                        );
                        if (confirmed) {
                          await api.delete(`/api/admin/discount-assignments/${a.id}`);
                          fetchData();
                        }
                      }}
                      title={a.times_used > 0 ? "Cannot delete: code has already been used." : "Delete this assignment"}
                    >
                      🗑️ Delete
                    </Button>

                  </td>
                </tr>
              ))}
              {sortedAssignments.length === 0 && (
                <tr>
                  <td colSpan={8} style={{ textAlign: "center", padding: "16px", backgroundColor: "#452654" }}>
                    No discount assignments found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Box>

        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="outlined" disabled={page === 1} onClick={() => fetchData(page - 1, searchQuery)}>⬅ Prev</Button>
          <Button variant="outlined" disabled={page === totalPages} onClick={() => fetchData(page + 1, searchQuery)}>Next ➡</Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminDiscountAssignments;
